import React from 'react';
import StatisticsRow, {
  StatisticItem,
} from '../../../../components/global/data-display/StatisticsRow';

interface ChangelogSummaryProps {
  title?: string;
  stats: StatisticItem[];
}

const ChangelogSummary: React.FC<ChangelogSummaryProps> = ({ title, stats }) => {
  if (stats.find(s => s.title.includes('Value'))?.value === '0') return null;

  return <StatisticsRow title={title} stats={stats} variant="greyOnWhite" skipEmptyValues />;
};

export default ChangelogSummary;
